import { getKeyCode } from 'state/secondaryMarket/utils';
import type { AppState } from 'state/state.model';
import { getProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.selector';

export function getDlpProductState(state: AppState, isin: string) {
  return state.secondaryMarket.referential.dlpProduct[isin];
}

export function getSecondaryMarketDlpProductFromTab(state: AppState, tabId: string) {
  const rowId = getProductKey(state, tabId);
  const isin = getKeyCode(rowId);
  return isin !== undefined ? getDlpProductState(state, isin) : undefined;
}

export function isSecondaryMarketDlpProductNotLoaded(appState: AppState, isin: string) {
  const state = getDlpProductState(appState, isin);
  return state === undefined || state.hasError;
}

export function isSecondaryMarketDlpProductLoading(appState: AppState, isin: string) {
  const state = getDlpProductState(appState, isin);
  return state?.isLoading;
}

export function getSecondaryMarketDlpProductIsinFromTab(appState: AppState, tabId: string) {
  return getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.isin;
}
export function getProductSummaryFieldMetadata(appState: AppState, tabId: string) {
  return getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.productSummaryMetadata;
}

export function getAvailableCustodians(appState: AppState, tabId: string) {
  return getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.tradeInformationMetadata?.availableCustodians;
}

export function getDisabledTradeWays(appState: AppState, tabId: string) {
  return (
    getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.tradeInformationMetadata?.disabledTradeWays ??
    emptyArray
  );
}

export function getMaxAsk(appState: AppState, tabId: string) {
  return getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.tradeInformationMetadata?.maxAsk;
}

export function getMaxBid(appState: AppState, tabId: string) {
  return getSecondaryMarketDlpProductFromTab(appState, tabId)?.data?.tradeInformationMetadata?.maxBid;
}

const emptyArray: readonly [] = [];
